import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getStoriesList, markSlideViewed } from '../api/storiesApi'
import type { StoriesResponse, StoryViewResponse } from '../types'

export const STORIES_QUERY_KEY = ['stories', 'list'] as const

/**
 * React Query-запрос ленты историй.
 * @param limit - сколько историй запросить (по умолчанию — как отдаёт бэк)
 * @param enabled - включён ли запрос
 */
export const useStoriesQuery = (limit?: number, enabled = true) =>
  useQuery<StoriesResponse>(
    [...STORIES_QUERY_KEY, limit ?? null],
    () => getStoriesList(limit),
    { enabled, staleTime: 60_000, retry: false },
  )

/**
 * Мутация отметки слайда просмотренным. Прогресс истории из ответа сразу
 * кладётся в кеш ленты (без рефетча) — чтобы кружок перекрасился и после
 * закрытия просмотрщика история уехала в конец, но лента не дёргалась запросом.
 *
 * Дебаунс быстрых кликов делается на стороне вызова (в просмотрщике), чтобы
 * уходил только последний slide_id в рамках одной истории.
 */
export const useMarkSlideViewedMutation = () => {
  const qc = useQueryClient()
  return useMutation<StoryViewResponse, Error, number>(markSlideViewed, {
    onSuccess: (res) => {
      qc.setQueriesData<StoriesResponse | undefined>(
        STORIES_QUERY_KEY,
        (prev) => {
          if (!prev) return prev
          return {
            ...prev,
            stories: prev.stories.map((s) =>
              s.story_id === res.view.story_id ? { ...s, view: res.view } : s,
            ),
          }
        },
      )
    },
  })
}
